/* eslint-disable no-undef */
/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { getStatus } from 'helpers/status-badge';
import StatusBadge from 'components/custom/ui/StatusBadge';
import { Icon } from '@iconify/react';
import { FeatherIcon } from 'feather-icons-react';
import { formatDate, formatTimeToAmPm } from 'services/utils';

const shiftListColumn = [
  {
    accessorKey: 'shift_name',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-primary-100 rounded me-2">
            <Icon
              icon="fluent:number-symbol-16-regular"
              fontSize={16}
              className="text-primary-600 dark__text-primary-300"
            />
          </div>
          <span>Shift</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => (
      <div
        className="text-break"
        title={original.shift_name}
        style={{
          maxWidth: '200px',
          overflow: 'hidden',
          webkitLineClamp: '1',
          textOverflow: 'ellipsis'
        }}
      >
        {' '}
        {original.shift_name}{' '}
      </div>
    ),
    meta: {
      headerProps: {
        className: 'ps-0'
        // style: { width: '15%', maxWidth: '15%' }
      },
      cellProps: {
        className: 'white-space-nowrap ps-0 text-primary'
        // style: { width: '15%', maxWidth: '15%' }
      }
    }
  },
  {
    accessorKey: 'start_time',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-primary-100 rounded me-2">
            <Icon
              icon="mdi:clock"
              fontSize={16}
              className="text-info-600 dark__text-info-300"
            />
          </div>
          <span>Start Time</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => formatTimeToAmPm(original.start_time),
    meta: {
      headerProps: { className: 'ps-0' },
      cellProps: { className: 'white-space-nowrap ps-0' }
    }
  },
  {
    accessorKey: 'end_time',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-primary-100 rounded me-2">
            <Icon
              icon="mdi:clock"
              fontSize={16}
              className="text-info-600 dark__text-primary-300"
            />
          </div>
          <span>End Time</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => formatTimeToAmPm(original.end_time),
    meta: {
      headerProps: { className: 'ps-0' },
      cellProps: { className: 'white-space-nowrap ps-0' }
    }
  },
  {
    accessorKey: 'status',
    header: 'status',
    cell: ({ row: { original } }) => (
      <StatusBadge
        status={original.status}
        getStatus={getStatus}
        lastComment={original.last_comment}
        flag={original.change_flag}
      />
    )
  }
];

export default shiftListColumn;
